import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 'calc(100vh - 22vh)',
    '& *': {
      lineHeight: '100%',
    },
    '& .MuiTable-root': {
      margin: theme.spacing(0, 0, 4),
    },
    '& .MuiTableCell-root': {
      borderBottom: 'none',
      padding: theme.spacing(1, 0),
      width: 200,
    },
    '& .MuiTableHead-root .MuiTableRow-root:first-child': {
      height: 209,
    },
    '& .MuiTableCell-root:first-child': {
      width: 'auto',
    },
    '& .MuiChip-root': {
      padding: theme.spacing(2),
    },
    '& .MuiTypography-h3': {
      margin: theme.spacing(2, 0, 1.8),
      fontSize: 16,

      fontWeight: 600,
      '& .MuiTypography-root': {
        color: theme.palette.primary.main,
      },
    },
  },
  headingBox: {
    '& .MuiTypography-h1': {
      fontSize: 30,
      fontWeight: 600,
    },
    '& .MuiTypography-body1': {
      fontSize: 16,
      fontWeight: 400,
    },
  },
  featurelabel: {
    fontSize: 16,
    fontWeight: 400,
  },
  trialDaysText: {
    fontSize: 16,
    fontWeight: 600,
  },
  pricesTyo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 28,
    fontWeight: 600,
    margin: theme.spacing(1, 0, 1.8),
    '& .MuiTypography-root': {
      fontSize: 12,
      marginLeft: theme.spacing(0.5),
      fontWeight: 600,
    },
  },
  roundBox: {
    width: 19.04,
    height: 19.04,
    borderRadius: 20,
    margin: theme.spacing(0, 'auto'),
    background: theme.palette.grey[300],
  },

  button: {
    fontSize: 16,
    fontWeight: 500,
    width: 140,
    height: 40,
    borderRadius: 40,
    margin: theme.spacing(1.2, 'auto'),
  },
  currencySelect: {
    width: '100px',
    borderRadius: 20,
    backgroundColor: '#eeeeee',
    color: 'black',
    fontWeight: 500,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
      borderRadius: '20px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiSelect-select': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& .MuiSelect-icon': {
      top: 'calc(50% - 14px)',
      right: '6px',
    },
    '& .MuiMenu-paper': {
      borderRadius: '1.5rem',
      overflow: 'hidden',
      background: 'red',
      boxShadow: '2px 2px 6px #8888884d',
    },
  },
  customMenuPaper: {
    boxShadow: '2px 2px 6px #8888884d',
  },
  menuItem: {
    borderRadius: '20px',
    margin: '4px 8px',
    padding: '6px 14px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '&.Mui-selected': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      borderRadius: '20px',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
      },
    },
  },
  roundedContainer: {
    width: 20,
    height: 20,
    borderRadius: '32px',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '5px',
  },
  containedImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  toggleButtonGroup: {
    borderRadius: '4rem',
    minWidth: 186,
    border: `5px solid ${theme.palette.grey[200]}`,
    backgroundColor: theme.palette.grey[200],
    margin: theme.spacing(2, 0, 3),
    '& .MuiButton-outlinedPrimary': {
      color: 'inherit',
    },

    '& .MuiButton-label': {
      fontSize: 14,
      fontWeight: 600,
    },
    '& .MuiButton-root:first-child': {
      borderRadius: '1.5rem',
      minWidth: 88,
      height: 33,
    },
    '& .MuiButton-root:last-child': {
      borderRadius: '1.5rem',
      minWidth: 88,
      height: 33,
    },
    '& .MuiButton-root:hover': {
      background: 'transparent',
      color: theme.palette.grey[800],
    },
    '& .MuiButton-root': {
      border: '0',
    },
  },
  selectedPlanInterval: {
    background: theme.palette.primary.main,
    color: `${theme.palette.common.white} !important`,
  },
  noHover: {
    '&:hover': {
      background: `${theme.palette.primary.main} !important`,
      cursor: 'default',
    },
  },
  statusBox: {
    backgroundColor: theme.palette.grey[200],
    borderRadius: theme.shape.borderRadius,
  },
  verticalBottomAlign: {
    verticalAlign: 'bottom',
    fontWeight: 500,
    fontSize: 20,
  },
  recommendedTag: {
    position: 'absolute',
    top: -15,
    color: theme.palette.grey[900],
    backgroundColor: theme.palette.common.white,
    transform: 'translateX(-50%)', // moves the tag to overlap right border
    zIndex: 10,
    borderWidth: 2,
  },
  paddingTop: {
    paddingTop: 18,
  },
  promotedCell: {
    position: 'relative',
  },
  promotedColumn: {
    borderLeft: `2px solid ${theme.palette.primary.main}`,
    borderRight: `2px solid ${theme.palette.primary.main}`,
  },
  promotedColumnTop: {
    borderTop: `2px solid ${theme.palette.primary.main}`,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    borderLeft: `2px solid ${theme.palette.primary.main}`,
    borderRight: `2px solid ${theme.palette.primary.main}`,
  },
  promotedColumnBottom: {
    borderBottom: `2px solid ${theme.palette.primary.main} !important`,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    borderLeft: `2px solid ${theme.palette.primary.main}`,
    borderRight: `2px solid ${theme.palette.primary.main}`,
  },
  currentPlan: {
    margin: theme.spacing(1, 0, 0.4),
    '& .MuiTypography-root ': {
      fontSize: 16,
      fontWeight: 600,
    },
  },
  subtext: {
    fontSize: 13,
    fontWeight: 400,
    marginTop: theme.spacing(0.8),
  },

  billingheading: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: theme.spacing(6),
  },
  subLabel: {
    fontSize: 16,
    fontWeight: 600,
  },
  section: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  section1: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(4),
    '& .MuiTypography-root:nth-child(2)': {
      flex: 1,
    },
  },
  Label: {
    fontSize: 16,
    fontWeight: 400,
  },
  planinfo: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(3, 0),
    },
  },
  canceltext: {
    fontSize: 16,
    fontWeight: 500,
    color: theme.palette.error.main,
    marginLeft: theme.spacing(2),
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.error.dark,
    },
  },
  currentPlanCard: {
    width: '100%',
    borderRadius: 12,
    padding: theme.spacing(4),
    alignItems: 'center',
    margin: theme.spacing(5, 0, 0),

    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(5, 4, 0),
      width: 'calc(100% - 100px)',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      margin: theme.spacing(5, 0, 0),
    },
  },
  width25: {
    width: '25%',
  },
  width35: {
    width: '35%',
  },
  width40: {
    width: '40%',
  },
  width75: {
    width: '75%',
  },
}))

export default useStyles
